import moment from "moment";

export const getFormattedDate = (date) => {
  return date ? moment(date, "YYYY-M-D HH:mm:ss").format("DD/MM/YYYY") : '-';
};

export const getCustomFormat = (date, format) => {
  return date ? moment(date, "YYYY-M-D HH:mm:ss").format(format) : '-';
};
